import React, { useState } from "react";
import Hero from "../../components/hero/Hero";
import Podcast from "../../components/podcast/Podcast";
import Books from "../../components/books/Books";
import Blogs from "../../components/blogs/Blogs";
import Fellowships from "../../components/fellowships/Fellowships";
import Calendar from "../../components/calendar/Calendar";
import Teachings from "../../components/teachings/Teachings";
import Announcements from "../../components/announcement/Announcements";
// import Ministry from "../../components/ministry/Ministry"; // store section hidden
import Others from "../../components/others/Others";

import GifModal from "./modal/GifModal";
import { LoadingGif } from "../../images/images";
import InfoSlide from "../../components/info-slide/InfoSlide";

import "./homepage-animations.css";
import Testimonials from "../../components/testimony/Testimonials";
import "./Homepage.css";
import Engage from "../engage/Engage";
import Mini from "../mini/Mini";
// TestimonialsScroller not used; removed import

function Homepage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <GifModal
        open={showModal}
        videoSrc={LoadingGif}
        onViewWebsite={() => setShowModal(false)}
      />

      {!showModal && (
        <>
          <Hero />
          <div className="homepage-info">
            <InfoSlide text="Jesus to ends of the earth." />
          </div>

          <div className="homepage-announcements">
            <Announcements />
          </div>

          {/* "From Our Ministry Store" is hidden for now
          <div className="homepage-ministry">
            <Ministry />
          </div> */}

          <div className="homepage-books">
            <Books />
          </div>

          {/* <div className="homepage-others">
            <Others />
          </div> */}

          <div className="homepage-testimonials">
            <Testimonials />
          </div>

          <div className="homepage-blogs">
            <Blogs />
          </div>

          <div className="homepage-engage">
            <Engage />
          </div>

          <div className="homepage-mini">
            <Mini />
          </div>

          <div className="homepage-fellowships">
            <Fellowships />
          </div>

          {/* <div className="homepage-calendar">
            <Calendar />
          </div> */}

          <div className="homepage-teachings">
            <Teachings />
          </div>

          {/* <TestimonialsScroller /> */}

          {/* 
          <div className="scroll-animate scroll-zoom">
            <Podcast />
          </div> */}
        </>
      )}
    </div>
  );
}

export default Homepage;
